import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ErrorBannerConfig, ErrorBannerService } from '../../services/error-banner.service';

@Component({
  standalone: false,
  selector: 'app-error-banner',
  templateUrl: './error-banner.component.html',
  styleUrls: ['./error-banner.component.scss'],
})
export class ErrorBannerComponent implements OnInit, OnDestroy {
  showBanner = false;

  private subscription: Subscription;

  constructor(private errorBannerService: ErrorBannerService) {}

  get supportEmail(): string {
    const currentDomain = window.location.hostname;

    if (currentDomain.includes('utmc')) {
      return 'utmc-support@triexcms.com';
    }
    if (currentDomain.includes('stopclaims')) {
      return 'stopclaims-support@triexcms.com';
    }
    // Default fallback
    return 'utmc-support@triexcms.com';
  }

  ngOnInit(): void {
    this.subscription = this.errorBannerService.banner$.subscribe((config: ErrorBannerConfig) => {
      this.showBanner = config.show;
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  onRefreshClick(): void {
    this.errorBannerService.refreshPage();
  }
}
